<template>
  <div id="group-hotels-list">
    <SidebarLayout2 :breadcrumb="breadcrumb" pageTitle="Agrupador de hotéis">
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading>
            Ações da página
          </Heading>

          <Button
            :hasIcon="true"
            class="page-actions--button"
            @click="$router.push({ path: '/agrupador-hoteis/novo' })"
          >
            Criar agrupador
          </Button>

          <Button
            :disabled="disableEditButton"
            class="page-actions--button"
            @click.stop.prevent="
              $router.push({
                path: `/agrupador-hoteis/editar/${selectedRows[0].codigo}`
              })
            "
          >
            Editar
          </Button>

          <Button
            :disabled="disabledDeleteButton"
            variation="error"
            class="page-actions--button"
            @click.stop.prevent="deleteModal()"
          >
            Excluir
          </Button>
        </SidebarBlock>

        <!-- DICAS -->
        <SidebarBlock>
          <Heading>
            Dica
          </Heading>

          <Paragraph class="page-actions--tip-text">
            Crie Agrupadores de Hotéis para simplificar e otimizar a gestão de
            Tarifas Master e Produtos Master. Agrupe hotéis por região, tipo ou
            estratégia de campanha, facilitando a aplicação de ações em massa,
            análise estratégica de resultados e filtragem nas listagens de
            reservas e relatórios dos hotéis.<br /><br />Exemplo: Com um
            Agrupador de Hotéis, você pode aplicar uma Tarifa Master ou Produto
            Master a dezenas de hotéis instantaneamente, sem o processo
            repetitivo de selecionar manualmente cada hotel.
          </Paragraph>
        </SidebarBlock>
      </template>

      <!-- CONTEÚDO -->
      <template #content>
        <span class="filters">
          <!-- BUSCA -->
          <SearchInput v-model="filterByName" class="filters--search-input" />
        </span>

        <!-- TABELA -->
        <DataTable
          :cols="cols"
          :sortable="true"
          :isLoading="loading"
          :rows="rows"
          :selectableRow="true"
          :colsMinWidths="minWidths"
          maxHeight="none"
          ref="dataTable"
          class="datatable"
          @getSelectedRows="selectedRows = $event"
        >
          <template v-slot:nome="data">
            {{ data.rowDataObj.nome }}

            <button
              class="datatable--info-button"
              @click.stop.prevent="buttonInfo(data.rowDataObj.codigo)"
            >
              <Icon icon="info" class="datatable--info-icon" />
            </button>
          </template>

          <template v-slot:editar="data">
            <div>
              <button
                class="datatable--link datatable--link__edit"
                @click.stop.prevent="
                  $router.push({
                    path: `/agrupador-hoteis/editar/${data.rowDataObj.codigo}`
                  })
                "
              >
                Editar
              </button>
            </div>
          </template>

          <template v-slot:excluir="data">
            <div>
              <button
                class="datatable--link datatable--link__delete"
                @click.stop.prevent="deleteModal(data.rowDataObj.codigo)"
              >
                Excluir
              </button>
            </div>
          </template>
        </DataTable>

        <!-- PAGINAÇÃO -->
        <PmwPagination
          :items="filterTable"
          :itemsPerPage="pagination.itemsPerPage"
          :currentPage="pagination.currentPage"
          :totalItems="filterTable.length"
          :itemsPerPageOptions="pagination.itemsPerPageOptions"
          class="pagination"
          @changePagination="changePagination"
        />

        <!-- MODAL DELEÇÃO -->
        <AlertModal
          v-model="showDeleteModal"
          :buttonClose="true"
          title="Excluir agrupador de hotéis"
          @alert-modal-cancel="cancelDisable()"
          @alert-modal-confirm="disableHotel()"
        >
          <template #text>
            Ao excluir esse agrupador, não será mais possível visualizar as
            informações contidas nele de forma compilada em relatórios. <br />
            Tem certeza de que quer fazer isso?
          </template>
        </AlertModal>

        <Modal
          v-model="modalTable"
          :hasFooter="false"
          :width="'auto'"
          :smallerHeader="true"
          :smallHeader="true"
          :title="title"
          id="modal"
          class="modal"
          @modal-cancel="clearSelected()"
        >
          <template slot="body-content">
            <div class="modal-info">
              <div class="row">
                <div v-if="hotels.length > 0" class="col modal-spaces">
                  <CleanTable :columns="hotelsColumns" :rows="hotels" />
                </div>

                <div v-else>
                  Não existem hotéis cadastrados neste agrupador
                </div>
              </div>
            </div>
          </template>
        </Modal>
      </template>
    </SidebarLayout2>
  </div>
</template>

<script>
/** Componentes da lib */
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'
import Button from '@solucoes/components-lib-tmp/src/components/elements/Button'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import PmwPagination from '@solucoes/components-lib-tmp/src/components/patterns/PmwPagination'
import SearchInput from '@solucoes/components-lib-tmp/src/components/elements/SearchInput'
import Icon from '@solucoes/components-lib-tmp/src/components/elements/Icon'
import Paragraph from '@solucoes/components-lib-tmp/src/components/elements/Paragraph'
import Modal from '@solucoes/components-lib-tmp/src/components/patterns/Modal'
import CleanTable from '@solucoes/components-lib-tmp/src/components/patterns/CleanTable'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'

/** Imports do projeto */
import SidebarLayout2 from '@/layouts/SidebarLayout2'

export default {
  name: 'HotelBundlerList',

  components: {
    AlertModal,
    Button,
    DataTable,
    Heading,
    PmwPagination,
    SearchInput,
    Icon,
    Paragraph,
    Modal,
    CleanTable,
    SidebarLayout2,
    SidebarBlock
  },

  data() {
    return {
      hotelsColumns: [
        {
          label: 'Hotéis',
          value: 'nome',
          name: 'nome'
        }
      ],

      hotels: [],

      breadcrumb: [
        {
          label: 'Configurações'
        },
        {
          label: 'Agrupador de hotéis'
        }
      ],

      minWidths: {
        nome: '60px',
        editar: '70px',
        excluir: '70px'
      },

      /** Colunas da tabela */
      cols: [
        {
          alias: 'Nome',
          name: 'nome'
        },
        {
          alias: 'Hotéis',
          name: 'grouper'
        },
        {
          alias: 'Ações',
          name: 'editar',
          sortable: false
        },
        {
          alias: '',
          name: 'excluir',
          sortable: false
        }
      ],

      /** V-model da busca */
      filterByName: '',

      /** Dados da paginação */
      pagination: {
        totalItems: 0,
        currentPage: 1,
        itemsPerPage: 25,
        startItemIndex: 1,
        lastItemIndex: 25,
        itemsPerPageOptions: [
          {
            text: '25',
            value: 25
          },
          {
            text: '50',
            value: 50
          },
          {
            text: '75',
            value: 75
          },
          {
            text: '100',
            value: 100
          }
        ]
      },

      /** Linhas da tabela (dados) */
      rows: [],

      /** Armazena dados de retorno */
      allHotels: [],

      /** Loading da tabela */
      loading: true,

      /** Array das linhas selecionadas */
      selectedRows: [],

      /** Hotel a ser deletado */
      hotelDelete: null,

      /** Exibição da modal de remoção */
      showDeleteModal: false,

      /** titulo de modal de informação */
      title: null,

      modalTable: false,

      selectedBundler: null
    }
  },

  computed: {
    /** Desabilita botão de deletar */
    disabledDeleteButton() {
      if (this.selectedRows.length >= 1) {
        return false
      }
      return true
    },

    /** Desabilita botão de editar */
    disableEditButton() {
      if (this.selectedRows.length === 1) {
        return false
      }
      return true
    },

    /** Filtro de pesquisa da tabela */
    filterTable() {
      const results = this.allHotels.filter((data) => {
        return (
          data.nome.toLowerCase().indexOf(this.filterByName.toLowerCase()) > -1
        )
      })
      return results
    }
  },

  created() {
    this.getAll()
  },

  methods: {
    /**
     * Ação do botão de informação
     * @param {String} codigo: Id do agrupador de hotéis
     */
    buttonInfo(codigo) {
      this.modalTable = true
      this.getSingleGrouper(codigo)
      this.selectedBundler = codigo
    },

    /** Retorna dados da listagem */
    getAll() {
      this.loading = true

      this.$hotel.getHotelBundlers().then((response) => {
        const results = response.data

        results.map(function(key, index) {
          results[index]['data'] = {
            nome: key.nome,
            codigo: key.codigo,
            grouper: key.hoteis.map((item) => item.nome).join(', '),
            hoteis: key.hoteis
          }
        })

        this.allHotels = results
        this.loading = false
      })
    },

    /**
     * Retorna dados do agrupador
     * @param {String} codigo: Id do agrupador de hotéis
     */
    getSingleGrouper(codigo) {
      this.$hotel.getHotelBundlers(codigo).then((response) => {
        const hotels = response.data.hoteis
        this.title = response.data.nome

        if (hotels.length > 0) {
          hotels.map(function(item) {
            return item
          })

          this.hotels = hotels
        } else {
          this.hotels = []
        }
      })
    },

    /** Desabilitar grupo de hotéis */
    disableHotel() {
      this.loading = true

      const deleteHotelBundler = this.hotelDelete
        ? this.hotelDelete
        : this.selectedRows.map((item) => parseInt(item.codigo))

      this.$hotel
        .disableHotelBundlers({ agrupadores: deleteHotelBundler })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de hotéis excluido com sucesso'
          })
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao desativar agrupador de hotéis'
          })
        })
        .finally(() => {
          this.loading = false
          if (!this.hotelDelete) this.selectedRows = []
          this.getAll()
          this.cancelDisable()
          this.resetPagination()
        })
    },

    /**
     * Controle de remoção
     * @param {String} hotelId: Id do hotel
     */
    deleteModal(hotelId = null) {
      this.showDeleteModal = true
      this.hotelDelete = hotelId
    },

    /** Cancela deleção */
    cancelDisable() {
      this.showDeleteModal = false
      this.bedroomDelete = null
      this.hotelDelete = null
    },

    /**
     * Usado para controle da paginação
     * @param {Object} childData
     */
    changePagination(childData) {
      this.pagination.currentPage = childData.currentPage
      this.rows = childData.items
    },

    /** Reseta dados da paginação */
    resetPagination() {
      this.pagination.currentPage = 1
      this.pagination.startItemIndex = 1
      this.pagination.itemsPerPage = 25
      this.pagination.lastItemIndex = this.pagination.itemsPerPage
    },

    /** Limpa agrupador selecionado */
    clearSelected() {
      this.selectedBundler = null
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  pointer-events: none;
}

::v-deep .content {
  /** Padding abaixo do título da página */
  .page-heading {
    padding-bottom: 24px;
  }
}

.sidebar {
  &-title {
    color: #474747;
    margin-top: 35px;
    margin-bottom: 15px;
    margin-left: 15px;
    max-width: 215px;
  }

  &-tip-title {
    color: #474747;
    margin-top: 35px;
    max-width: 215px;
  }

  &-tip-text {
    color: #474747;
    font-size: 14px;
    line-height: 21px;
    max-width: 215px;
  }

  &-buttons {
    display: flex;
    flex-direction: column;
    margin-bottom: 50px;
    width: 215px;
    gap: 10px;
    margin: auto;
  }
}

.filters {
  display: flex;
  gap: 20px;
  margin-bottom: 40px;

  &--search-input {
    width: 215px;
  }
}

.datatable {
  &--info-button {
    background-color: transparent;
    background-repeat: no-repeat;
    border: none;
    cursor: pointer;
    overflow: hidden;
    outline: none;
  }

  &--info-icon {
    margin-left: 5px;
    height: 15px;
    width: 15px;
    color: #7f7f7f;
    transition: color $pmw-color-anim linear;

    &:hover {
      color: $pmw-blue;
    }
  }

  &--link {
    font-weight: font-weight('weight-medium');

    &__edit {
      border: none;
      background-color: inherit;
      color: #466af0;
    }

    &__delete {
      border: none;
      background-color: inherit;
      color: #e0414b;
    }
  }

  ::v-deep {
    .pmw-col.pmw-th:nth-child(4) {
      border-right: none;
    }

    .pmw-col.pmw-th:nth-child(4),
    .pmw-col.pmw-td:nth-child(4),
    .pmw-col.pmw-th:nth-child(5),
    .pmw-col.pmw-td:nth-child(5) {
      max-width: 70px;
    }
  }
}

.modal-info {
  padding: 25px;
}

.page-actions {
  padding-top: 50px;

  &--button {
    width: 100%;
    cursor: pointer;

    & + .page-actions--button {
      margin-top: 10px;
    }
  }

  &--tip-text {
    color: #474747;
    font-size: 14px;
    line-height: 21px;
    max-width: 215px;
  }
}

.pagination {
  ::v-deep .pmw-pagination {
    width: 100%;
  }
}
</style>
